import {
  LayoutConfig as ILayoutConfig,
  ReviewsSummaryConfig as IReviewsSummaryConfig,
  SpectrumConfig as ISpectrumConfig
} from 'services/api-service'

type BreakdownReviewsCountBy = 'NUMBER' | 'PERCENTAGE'

export class ReviewsSummaryConfig implements IReviewsSummaryConfig {
  constructor(config: IReviewsSummaryConfig) {
    this.aggregateMetaOn = config.aggregateMetaOn
    this.aggregateJsonLdMetaOn = config.aggregateJsonLdMetaOn
    this.breakdownReviewsCountBy = config.breakdownReviewsCountBy || 'PERCENTAGE'
    this.breakpoints = config.breakpoints
    this.childWidgets = config.childWidgets || {}
    this.dimFiltersOn = config.dimFiltersOn
    this.headingLevel = config.headingLevel || 2
    this.layouts = config.layouts
    this.showRangeMiddle = config.showRangeMiddle
    this.widgetDivId = config.widgetDivId
  }

  aggregateMetaOn: boolean
  aggregateJsonLdMetaOn: boolean
  breakdownReviewsCountBy?: BreakdownReviewsCountBy
  breakpoints?: Array <ILayoutConfig>
  childWidgets?: { [name: string]: unknown } // gallery | spectrum
  dimFiltersOn: boolean
  headingLevel: number
  layouts?: Array <ILayoutConfig>
  showRangeMiddle: boolean
  spectrumConfig?: ISpectrumConfig
  widgetDivId: string
}

let defaultConfig: IReviewsSummaryConfig = {}
export function loadConfig(config: IReviewsSummaryConfig): void {
  defaultConfig = new ReviewsSummaryConfig(config)
}

export { defaultConfig as default }
